import React from "react";

import Pagination, { IPaginationProps } from "../../Pagination";

import "./styles.scss";

export interface TableConditionChip {
  id: string;
  label: string;
  onRemove?: () => void;
  removeAriaLabel?: string;
}

export interface ConfigurableTableLayoutProps {
  controls?: React.ReactNode;
  conditionChips?: TableConditionChip[];
  onClearAllConditions?: () => void;
  clearAllLabel?: string;
  tableContent: React.ReactNode;
  pagination?: IPaginationProps;
  className?: string;
  onContainerClick?: () => void;
}

const ConfigurableTableLayout: React.FunctionComponent<
  ConfigurableTableLayoutProps
> = ({
  controls,
  conditionChips = [],
  onClearAllConditions,
  clearAllLabel,
  tableContent,
  pagination,
  className,
  onContainerClick,
}) => {
  const rootClassName = ["refactored-facility-table-wrap", className]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName} onClick={onContainerClick}>
      {controls && (
        <div className="refactored-controls-bar">
          <div className="right-tools">{controls}</div>
        </div>
      )}

      {(conditionChips.length > 0 ||
        (onClearAllConditions && clearAllLabel)) && (
        <div className="active-conditions-bar">
          <div className="conditions-flow">
            {conditionChips.map((condition) => (
              <div className="condition-chip-item" key={condition.id}>
                <span className="condition-chip-text">{condition.label}</span>
                {condition.onRemove && (
                  <button
                    type="button"
                    className="remove-btn"
                    onClick={condition.onRemove}
                    aria-label={
                      condition.removeAriaLabel || `remove-${condition.id}`
                    }
                  >
                    ×
                  </button>
                )}
              </div>
            ))}
            {onClearAllConditions && clearAllLabel && (
              <button
                type="button"
                className="clear-all-link"
                onClick={onClearAllConditions}
              >
                {clearAllLabel}
              </button>
            )}
          </div>
        </div>
      )}

      {tableContent}

      {pagination && <Pagination {...pagination} />}
    </div>
  );
};

export default ConfigurableTableLayout;
